export const AVATAR_CHANNEL_LIST_SIZE = 50;

export const AVATAR_CHANNEL_LIST_SIZE_WITH_PADDING = 55;

/* This is calculated in px for the width of the text container */
export const CHANNEL_LAST_MESSSAGE_TRUNCATE_SIZE = 275;

/* This is calculated in px for the width of the text container */
export const CHANNEL_NAME_LIST_TRUNCATE_SIZE = 210;

/* This is calculated in px for the width of the text container */
export const CHANNEL_MEMBERS_SUBTEXT_TRUNCATE_SIZE = 241;
